/**
 * Mock database manager using localStorage to simulate backend master records.
 */
export class MockDb {
  constructor(storageKey, initialData = []) {
    this.storageKey = `boss_erp_mock_${storageKey}`;
    if (!localStorage.getItem(this.storageKey)) {
      localStorage.setItem(this.storageKey, JSON.stringify(initialData));
    }
  }

  getAll() {
    try {
      const val = localStorage.getItem(this.storageKey);
      return val ? JSON.parse(val) : [];
    } catch (e) {
      console.error("Failed to read mock db", e);
      return [];
    }
  }

  saveAll(data) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (e) {
      console.error("Failed to write to mock db", e);
    }
  }

  get(id) {
    const list = this.getAll();
    return list.find(item => String(item.id) === String(id)) || null;
  }

  create(payload) {
    const list = this.getAll();
    const newId = list.length > 0 ? Math.max(...list.map(item => Number(item.id) || 0)) + 1 : 1;
    const newItem = {
      id: newId,
      code: `${this.storageKey.split('_').pop().slice(0, 3).toUpperCase()}-${String(newId).padStart(3, '0')}`,
      status: 'Active',
      createdDate: new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }),
      ...payload
    };
    list.push(newItem);
    this.saveAll(list);
    return newItem;
  }

  update(id, payload) {
    const list = this.getAll();
    const idx = list.findIndex(item => String(item.id) === String(id));
    if (idx === -1) return null;
    const updatedItem = { ...list[idx], ...payload };
    list[idx] = updatedItem;
    this.saveAll(list);
    return updatedItem;
  }

  archive(id) {
    const list = this.getAll();
    const idx = list.findIndex(item => String(item.id) === String(id));
    if (idx === -1) return null;
    const item = list[idx];
    item.status = item.status === 'Active' ? 'Archive / Deactive' : 'Active';
    list[idx] = item;
    this.saveAll(list);
    return item;
  }

  delete(id) {
    let list = this.getAll();
    const originalLength = list.length;
    list = list.filter(item => String(item.id) !== String(id));
    this.saveAll(list);
    return list.length < originalLength;
  }
}
